import React from 'react';
import { useHistory } from 'react-router';
import { HTTPStatusCodes } from 'constants/httpStatusCodes';
import strings from 'strings';
import FPActionButton from 'UI/components/atoms/FPActionButton';
import {
  SvgNoCandidates,
  SvgNoCompanies,
  SvgNoHiringAuthority,
  SvgNoJobOrders
} from 'UI/res/icons/milano';

import ContentPageLayout from '../ContentPageLayout';
import EmptyPlaceholder from '../EmptyPlaceholder';

const emptyStateHeight = 400;

const {
  shared: {
    errors: { serverError, profiles: profileEmptyStates }
  }
} = strings;

/**
 * @param {Object} props
 * @param {Object} props.profileStatusMode
 * @param {number} props.responseStatusCode
 * @param {Object} props.status
 * @param {Function} props.onRefreshProfileClick
 * @param {string} props.entityRoute
 * @param {Object} props.entity
 */
const ProfileUiStateManager = ({
  profileStatusMode,
  status,
  responseStatusCode,
  onRefreshProfileClick,
  entityRoute,
  entity
}) => {
  const { loading, success } = profileStatusMode;
  const { id, title } = entity;

  const defaultTextButton = `Go to ${title} list`;
  const history = useHistory();
  const handleProfileClik = () => history.push(entityRoute);

  // To do add company profiles

  const profileIcons = {
    candidate: {
      Icon: SvgNoCandidates
    },
    joborder: {
      Icon: SvgNoJobOrders
    },
    hiringAuthority: {
      Icon: SvgNoHiringAuthority
    },
    company: {
      Icon: SvgNoCompanies
    },
    name: {
      Icon: SvgNoCandidates
    }
  };

  const profileIcon = profileIcons[id].Icon;

  const renderEmptyState = ({ Icon, textButton, emptyStrings, onClick }) => {
    return (
      <ContentPageLayout>
        <EmptyPlaceholder {...emptyStrings} customEmptyState={<Icon height={emptyStateHeight} />}>
          <FPActionButton text={textButton} onClick={onClick} />
        </EmptyPlaceholder>
      </ContentPageLayout>
    );
  };

  const emptyStates = {
    [HTTPStatusCodes.BadRequest]: renderEmptyState({
      Icon: profileIcon,
      textButton: defaultTextButton,
      emptyStrings: { ...profileEmptyStates[id].notFound },
      onClick: handleProfileClik
    }),
    [HTTPStatusCodes.NotFound]: renderEmptyState({
      Icon: profileIcon,
      textButton: defaultTextButton,
      emptyStrings: { ...profileEmptyStates[id].notFound },
      onClick: handleProfileClik
    }),
    [HTTPStatusCodes.InternalServerError]: renderEmptyState({
      Icon: profileIcon,
      textButton: 'Try again',
      emptyStrings: serverError,
      onClick: onRefreshProfileClick
    })
  };

  const profileStatus = {
    empty: emptyStates[responseStatusCode],
    loading,
    success,
    error: emptyStates[responseStatusCode] ?? emptyStates[500]
  };

  return profileStatus[status];
};

export default ProfileUiStateManager;
